import { render, staticRenderFns } from "./DiskUsageCard.vue?vue&type=template&id=03637973&"
import script from "./DiskUsageCard.vue?vue&type=script&lang=ts&"
export * from "./DiskUsageCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports